import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Asset, AffectedAsset } from '../../../../models/asset.model';
import { ASSET_STATUS_OPTIONS, NOT_AFFECTED_STATUS_OPTION } from '../../../../../status-badge/status.const';

@Component({
  selector: 'mtm-asset-status-dropdown',
  templateUrl: './asset-status-dropdown.component.html',
  styleUrl: './asset-status-dropdown.component.scss',
  standalone: false,
})
export class AssetStatusDropdownComponent {
  @Input() content!: Asset;
  @Input() affectedAssets!: Record<string, AffectedAsset>;
  @Input() showStatus!: boolean;
  @Input() projectStatus!: Record<string, string | undefined>;
  @Input() projectColor!: Record<string, string>;

  @Output() statusChange: EventEmitter<{ asset: AffectedAsset | undefined; status: string }> = new EventEmitter<{
    asset: AffectedAsset | undefined;
    status: string;
  }>();

  readonly assetStatusOptions = ASSET_STATUS_OPTIONS;
  readonly notAffectedOption = NOT_AFFECTED_STATUS_OPTION;

  public getCurrentStatus(): string {
    if (!this.affectedAssets[this.content.id]) {
      return 'NOT_AFFECTED';
    }
    return this.affectedAssets[this.content.id]?.status || 'UNKNOWN';
  }

  public isDropdownDisabled(): boolean {
    return !this.affectedAssets[this.content.id];
  }

  public onChangeStatus(status: string): void {
    this.statusChange.emit({
      asset: this.affectedAssets[this.content.id],
      status,
    });
  }

  public stopPropagation(event: Event): void {
    event.stopImmediatePropagation();
  }
}
